<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-users" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Enrollees</h4>
                <small style="opacity: .8;">Browse and filter enrollee records</small>
              </div>
            </div>
            <button type="button" class="btn btn-outline-light btn-sm"
              @click="getUserData(currentPage ? currentPage : 1)">
              <i class="fe fe-refresh-cw mr-1"></i> Refresh
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <SearchUser />

        <!-- Filter Card -->
        <div class="card table-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-sliders" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Filter Parameters</p>
              <small style="color:rgba(255,255,255,.7);">Narrow results by sector, location, HMO, and more</small>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-credit-card mr-1"></i>Program</label>
                <v-select v-model="selected_sectors" :options="sectors" :reduce="name => name.name" multiple
                  label="name"></v-select>
              </div>

              <div class="form-group col-md-3" v-if="agency.id == '313923'">
                <label class="info-label d-block mb-1" for="viewClientsSubProgramSelect"><i class="fe fe-credit-card mr-1"></i>Sub Program</label>
                <v-select input-id="viewClientsSubProgramSelect" v-model="sectorType" :options="sub_sectors"></v-select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Select LGA</label>
                <select class="form-control" v-model="localgovt" @change="fetchWards($event)">
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">{{ lga.local_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Provider LGA</label>
                <select class="form-control" v-model="provider_localgovt">
                  <option value="">All</option>
                  <option v-for="lga in lga_states" v-bind:key="lga.id" :value="lga.id">{{ lga.local_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-navigation mr-1"></i>Ward</label>
                <select class="form-control" v-model="ward">
                  <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">{{ ward.ward_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">HMO <span class="text-danger">*</span></label>
                <select class="form-control" required v-model="org_id">
                  <option v-for="org in tpas" v-bind:key="org" :value="org.id">{{ org.organization_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>First Name</label>
                <input type="text" class="form-control" placeholder="First Name" v-model="firstname" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Last Name</label>
                <input type="text" class="form-control" placeholder="Last Name" v-model="lastname" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Middle Name</label>
                <input type="text" class="form-control" placeholder="Middle Name" v-model="middlename" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Gender</label>
                <select class="form-control" v-model="gender">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-activity mr-1"></i>Facility</label>
                <select class="form-control" required v-model="provider_id">
                  <option v-for="provider in providers" v-bind:key="provider.id" :value="provider.id">{{
                    provider.agency_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-briefcase mr-1"></i>Place of Work</label>
                <select class="form-control" v-model="place_of_work">
                  <option :value="mda.name" v-for="mda in mdas" v-bind:key="mda.id">{{ mda.name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Special Needs</label>
                <select class="form-control" v-model="category_of_vulnerable_group">
                  <option value="All">All</option>
                  <option value="Pregnant Women">Pregnant Women</option>
                  <option value="Children under 5">Children under 5</option>
                  <option value="Aged">Aged</option>
                  <option value="People with Special Needs">People with Special Needs</option>
                  <option value="Poorest of the Poor">Poorest of the Poor</option>
                  <option value="Indegent">Indegent</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Select Employee</label>
                <select class="form-control" v-model="enrolled_by">
                  <option :value="emoployee.id" v-for="emoployee in employees.data" v-bind:key="emoployee.id">
                    {{ emoployee.firstname }} {{ emoployee.lastname }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Status</label>
                <select class="form-control" v-model="enabled_user">
                  <option value="1">Active</option>
                  <option :value="false">Inactive</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-layers mr-1"></i>Group By</label>
                <select class="form-control" v-model="group_by">
                  <option value="">None</option>
                  <option value="place_of_work">Place of Work</option>
                  <option value="provider">Provider</option>
                  <option value="hmo">HMO</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                <input type="date" class="form-control" v-model="from" @change="pushDate" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                <input type="date" class="form-control" v-model="to" @change="pushDate" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Rows per Page</label>
                <select class="form-control" v-model="perPage">
                  <option value="15">15</option>
                  <option value="50">50</option>
                </select>
              </div>

              <div class="col-md-12 pt-3 border-top">
                <div class="d-flex flex-wrap" style="gap:10px;">
                  <button @click="getUserData(currentPage ? currentPage : 1, 'json')" class="btn btn-submit px-4">
                    <i class="fe fe-filter mr-1"></i> Filter
                  </button>
                  <button @click="getTotalStats" class="btn btn-outline-secondary">
                    <i class="fe fe-file mr-1"></i> Total Stats
                  </button>
                  <button class="btn btn-outline-dark" @click="getUserData(0,'csv')">
                    <i class="fe fe-file-text mr-1"></i> Export Excel
                  </button>
                  <button @click="clearFilter" class="btn btn-outline-secondary ml-auto">
                    <i class="fe fe-x-circle mr-1"></i> Clear
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Results Table -->
        <div class="card table-card shadow mb-4">
          <div class="card-body pb-0">
            <div class="mb-3 d-flex align-items-start justify-content-between">
              <div>
                <p class="h5 mb-1">
                  Total Records:
                  <span class="text-primary">{{ (clients.meta.total_principal + clients.meta.total_dep) | numeral(0, 0)
                    }}</span>
                </p>
                <div class="d-flex" style="gap:16px; font-size:.85rem; color:#64748b;">
                  <span>Principals: <strong>{{ clients.meta.total_principal }}</strong></span>
                  <span>Dependents: <strong>{{ clients.meta.total_dep }}</strong></span>
                </div>
              </div>
              <div class="view-toggle">
                <button :class="['view-toggle-btn', viewMode === 'list' ? 'active' : '']" @click="viewMode = 'list'"
                  title="List view"><i class="fe fe-list"></i></button>
                <button :class="['view-toggle-btn', viewMode === 'grid' ? 'active' : '']" @click="viewMode = 'grid'"
                  title="Grid view"><i class="fe fe-grid"></i></button>
              </div>
            </div>
          </div>
          <div class="table-responsive" v-if="viewMode === 'list'">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Avatar</th>
                  <th class="table-th">Name</th>
                  <th class="table-th">Phone Number</th>
                  <th class="table-th">Sector</th>
                  <th class="table-th">Enrollee ID</th>
                  <th class="table-th text-center">Dependents</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="client in clients.data" v-bind:key="client.id">
                  <td>
                    <div class="avatar avatar-sm" v-if="client.user_image != null">
                      <img :src="`${client.image_url}`" class="avatar-img avatar-sm rounded-circle"
                        onerror="this.onerror=null; this.src='/assets/img/zamfara.jpg'" />
                    </div>
                    <div class="avatar avatar-sm" v-else>
                      <div class="avatar-title rounded-circle bg-soft-primary text-primary" style="font-size:.75rem;">
                        {{ client.full_name ? client.full_name.charAt(0) : '?' }}
                      </div>
                    </div>
                  </td>
                  <td class="font-weight-bold">{{ client.full_name }}</td>
                  <td>{{ client.phone_number }}</td>
                  <td>
                    <span class="badge badge-soft-info" style="font-size:.75rem;">{{ client.sector }}</span>
                  </td>
                  <td><span class="code-chip">{{ client.id_card_number }}</span></td>
                  <td class="text-center">
                    <span v-if="client.dependants_count !== undefined" class="badge badge-soft-secondary"
                      style="font-size:.75rem;">{{ client.dependants_count }}</span>
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td>
                    <div class="d-flex" style="gap:4px;">
                      <span v-if="user.id == agency.id">
                        <button class="btn btn-sm btn-outline-danger" @click="disableUser(client.id)"
                          v-if="client.enabled_user == 1">Disable</button>
                        <button class="btn btn-sm btn-outline-success" @click="enableUser(client.id)"
                          v-else-if="client.enabled_user == 0">Enable</button>
                      </span>
                      <router-link :to="{ path: '/client/' + client.id }" v-if="client.account_type == 'Principal'">
                        <button type="button" class="btn btn-sm btn-outline-primary"><i class="fe fe-eye"></i></button>
                      </router-link>
                      <router-link :to="{ path: '/dependent/' + client.id }" v-else>
                        <button type="button" class="btn btn-sm btn-outline-primary"><i class="fe fe-eye"></i></button>
                      </router-link>
                      <button class="btn btn-sm btn-outline-secondary" @click="getDependents(client)"
                        data-toggle="collapse" :data-target="'#collapseExample' + client.id" aria-expanded="false">
                        <i class="fe fe-users"></i>
                      </button>
                    </div>
                    <div class="collapse mt-2" :id="'collapseExample' + client.id">
                      <table class="table table-sm mb-0">
                        <tr>
                          <th style="font-size:.72rem;">Name</th>
                          <th style="font-size:.72rem;">Relationship</th>
                          <th style="font-size:.72rem;">Gender</th>
                        </tr>
                        <tr v-for="dep in dependents" v-bind:key="dep.id">
                          <td>{{ dep.firstname }} {{ dep.lastname }}</td>
                          <td>{{ dep.relationShipType }}</td>
                          <td>{{ dep.gender }}</td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clients-grid" v-if="viewMode === 'grid'">
            <div v-if="!clients.data || !clients.data.length" style="grid-column:1/-1"
              class="text-center py-5 text-muted">
              <i class="fe fe-users" style="font-size:2rem;opacity:0.3"></i>
              <p class="mt-2 mb-0">No enrollees found</p>
            </div>
            <div v-for="client in clients.data" :key="client.id" class="client-grid-card">
              <div class="d-flex align-items-center mb-3" style="gap:12px;">
                <div v-if="client.user_image" class="avatar avatar-sm">
                  <img :src="`${client.image_url}`" class="rounded-circle"
                    :alt="client.full_name || 'Enrollee photo'"
                    style="width:44px;height:44px;object-fit:cover;"
                    @error="$event.target.onerror = null; $event.target.src = '/claimify_logo.png'" />
                </div>
                <div v-else
                  class="rounded-circle d-flex align-items-center justify-content-center bg-soft-primary text-primary"
                  style="width:44px;height:44px;min-width:44px;font-size:.85rem;font-weight:700;">
                  {{ client.full_name ? client.full_name.charAt(0) : '?' }}
                </div>
                <div>
                  <div class="font-weight-bold" style="font-size:.9rem;">{{ client.full_name }}</div>
                  <span class="code-chip">{{ client.id_card_number }}</span>
                </div>
              </div>
              <div class="mb-3" style="font-size:.83rem;color:#64748b;">
                <div><i class="fe fe-phone mr-1"></i>{{ client.phone_number || '—' }}</div>
                <div class="mt-1"><span class="badge badge-soft-info" style="font-size:.75rem;">{{ client.sector
                    }}</span></div>
                <div class="mt-1" v-if="client.dependants_count !== undefined">
                  <i class="fe fe-users mr-1"></i>{{ client.dependants_count }}
                  {{ client.dependants_count == 1 ? 'dependent' : 'dependents' }}
                </div>
              </div>
              <div class="d-flex grid-card-footer" style="gap:6px;">
                <span v-if="user.id == agency.id">
                  <button class="btn btn-sm btn-outline-danger" @click="disableUser(client.id)"
                    v-if="client.enabled_user == 1">Disable</button>
                  <button class="btn btn-sm btn-outline-success" @click="enableUser(client.id)"
                    v-else-if="client.enabled_user == 0">Enable</button>
                </span>
                <router-link :to="{ path: '/client/' + client.id }" v-if="client.account_type == 'Principal'"
                  class="ml-auto">
                  <button type="button" class="btn btn-sm btn-outline-primary"><i
                      class="fe fe-eye mr-1"></i>View</button>
                </router-link>
                <router-link :to="{ path: '/dependent/' + client.id }" v-else class="ml-auto">
                  <button type="button" class="btn btn-sm btn-outline-primary"><i
                      class="fe fe-eye mr-1"></i>View</button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body pt-2">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
              @input="getUserData(currentPage ? currentPage : 1)"></b-pagination>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import SearchUser from "@/views/shis/component/SearchUser.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import sectorsJson from "@/json/sectors_dynamic.json";
  import vulnerablesJson from "@/json/vulnerables.json";
  import { downloadGroupedXlsx } from "@/service/xlsx_export";

  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: {
      Navbar,
      Loading,
      SearchUser,
    },
    data() {
      return {
        agency: agency,
        isLoading: false,
        fullPage: true,
        user: null,
        sub_sectors: [
          'Correctional', 'Rehabilitation',
          'Homes', 'IDP', 'Remand Homes',
          'Abbacare', 'Abbacare-Maternal', 'Khedfund2', 'WAQF', 'REMASAB', 'ABBACARE KANNYWOOD VULNERABLE PROGRAM'

        ],
        arrays: [
          {
            type: "Principal",
            name: "Fai Sal",
            gender: "male",
          },
          {
            type: "Dep",
            name: "Kam ol",
            gender: "female",
          },
        ],
        sectors: "",
        sectorType: "",
        selected_sectors: [],
        vulnerables: "",
        clients: {
          meta: {
            total_principal: 0,
            total_dep: 0,
          },
          data: [],
        },
        providers: "",
        mdas: "",
        wards: "",
        tpas: "",
        state: "",
        lga_states: "",
        category_of_vulnerable_group: "",
        employees: "",
        firstname: "",
        lastname: "",
        middlename: "",
        provider_id: "",
        sector: "",
        place_of_work: "",
        localgovt: "",
        provider_localgovt: "",
        dependents: "",
        enrolled_by: "",
        gender: "",
        org_id: "",
        group_by: "",
        enabled_user: 1,
        ward: "",
        date: "",
        from: "",
        to: "",
        current_page: 1,
        currentPage: 1,
        rows: "1",
        perPage: 15,
        viewMode: 'list',

      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    mounted() {
      this.viewMode = window.innerWidth < 768 ? 'grid' : 'list';

      //get Agency By ID
      let sectors = sectorsJson;
      let formatter = sectors.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.sectors = formatter;
      console.log(JSON.stringify(this.sectors) + "sectors");

      //get Vulnerables By ID
      let vulnerables = vulnerablesJson;
      let formatterVulnerables = vulnerables.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.vulnerables = formatterVulnerables;


    },
    methods: {
      getUserData(currentPage, format) {
        this.isLoading = true;

        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/getUsersfilterparams`, {
            params: {
              format: format ? format : "",
              page: currentPage,
              agency_id: agency.id,
              perPage: this.perPage ? this.perPage : null,
              provider_id: this.provider_id ? this.provider_id : "",
              sectors: this.selected_sectors ? this.selected_sectors : "",
              sectorType: this.sectorType ? this.sectorType : "",
              firstname: this.firstname ? this.firstname : "",
              lastname: this.lastname ? this.lastname : "",
              middlename: this.middlename ? this.middlename : "",
              gender: this.gender ? this.gender : "",
              org_id: this.org_id ? this.org_id : "",
              group_by: this.group_by ? this.group_by : "",
              enabled_user: this.enabled_user,
              place_of_work: this.place_of_work ? this.place_of_work : "",
              localgovt: this.localgovt ? this.localgovt : "",
              provider_localgovt: this.provider_localgovt ? this.provider_localgovt : "",
              enrolled_by: this.enrolled_by ? this.enrolled_by : "",
              date: this.date ? this.date : "",
              from: this.from ? this.from : "",
              to: this.to ? this.to : "",
              ward: this.ward ? this.ward : "",
              category_of_vulnerable_group: this.category_of_vulnerable_group
                ? this.category_of_vulnerable_group
                : "",
            },
          })
          .then((response) => {

            if (format === "csv") {
              const fileName = `enrollees_${new Date().toISOString().slice(0, 10)}.xlsx`;
              downloadGroupedXlsx(response.data, this.group_by, fileName);

              this.$toasted.success("Excel file downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });

              this.isLoading = false;
              return;
            }

            this.$toasted.success("Filtered Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.clients = response.data;
            this.rows = response.data.meta.total_principal;

            this.isLoading = false;

          })
          .catch((error) => {
            this.isLoading = false;

            console.error(error);
          });
      },

      clearFilter() {
        this.ward = "";
        this.date = "";
        this.from = "";
        this.to = "";
        this.sector = "";
        this.localgovt = "";
        this.provider_id = "";
        this.place_of_work = "";
        this.group_by = "";
        this.enrolled_by = "";
      },

      getTotalStats() {
        this.isLoading = true;

        this.axios
          .get(`/api/v1/auth/enrollee-stats/${this.agency.id}`)
          .then((response) => {
            // let total_stats = response.data;
            const data = response.data;
            const headers = Object.keys(data).join(",");
            const values = Object.values(data).join(",");
            const csv = [headers, values].join("\n");
            const blob = new Blob([csv], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `enrollee_stats_${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
            this.isLoading = false;
            this.$toasted.info("Total Report Generated Successfully!", {
              position: "top-center",
              duration: 3000,
            });

          })
          .catch((error) => {
            this.isLoading = false;

            console.error(error);
          });
      },
      getLGA() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/lga/${agency.state}`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      pushDate() {
        this.date = "date";
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/getEmployee/${agency.id}`)
          .then((response) => {
            this.employees = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDependents(client) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/allDependantUser/${client.id}`)
          .then((response) => {
            this.dependents = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      disableUser(user_id) {
        //   alert(user_id);
        this.axios
          .post(`/api/v1/auth/disableUser/` + user_id)
          .then(() => {
            alert("User disabled");
          })
          .catch((error) => {
            console.error(error);
          });
      },
      enableUser(user_id) {
        //   alert(user_id);
        this.axios
          .post(`/api/v1/auth/enableUser/` + user_id)
          .then(() => {
            alert("User enabled");
            this.getUsers();
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/${agency.id}`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      changeNumberID(client) {
        this.isLoading = true;
        this.axios
          .patch(`/api/v1/auth/id-card-number/change/${client.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Not Found!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          });
      },

      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/${agency.id}`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${agency.id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.getUserData();
      this.getLGA();
      this.getProviders();
      this.getMDAs();
      this.getEmployees();
      this.getTPAs();
    },
  };
</script>

<style scoped>
  /* ── View toggle ── */
  .view-toggle {
    display: flex;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  }

  .view-toggle-btn {
    background: none;
    border: none;
    padding: 6px 10px;
    color: #94a3b8;
    cursor: pointer;
    font-size: .85rem;
    line-height: 1;
  }

  .view-toggle-btn.active {
    background: #1e3a5f;
    color: #fff;
  }

  .view-toggle-btn:hover:not(.active) {
    background: #f1f5f9;
    color: #475569;
  }

  /* ── Grid view ── */
  .clients-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
    padding: 20px 24px;
  }

  .client-grid-card {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    transition: border-color .15s, box-shadow .15s;
  }

  .client-grid-card:hover {
    border-color: #93c5fd;
    box-shadow: 0 2px 10px rgba(37, 99, 235, .1);
  }

  .grid-card-footer {
    border-top: 1px solid #f1f5f9;
    padding-top: 10px;
    margin-top: auto;
  }

  .code-chip {
    background: #f1f5f9;
    color: #1e3a5f;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: .78rem;
    font-weight: 600;
  }
</style>